import GlobalStyle from "./styles/global"
import Layout from "./components/Layout";
import { ThemeProvider } from "styled-components";
import themes from "./styles/themes";
import { useMemo, useContext } from "react";
import { ThemeSiteContext } from "./context/ThemeContext";
import { FontStyles } from "./styles/FontStyled";


export default function App() {
  const { theme } = useContext(ThemeSiteContext)



  const currentTheme = useMemo(() => {
    return themes[theme.themeSite] || themes.dark
  }, [theme.themeSite])



  return (

    <ThemeProvider theme={currentTheme}>
      <FontStyles />
      <GlobalStyle />

      <Layout />
    </ThemeProvider>
  );
}


